<template>
  <v-menu
    ref="menu"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <slot
        name="ativador"
        :on="on"
      >
        <div
          v-bind="attrs"
          class="menu-dropdown-idiomas"
          v-on="on"
        >
          <img
            :src="
              idiomasPermitidos.find((el) => $i18n.locale == el.value)
                ?.imagem
            "
            width="30"
          >
        </div>
      </slot>
    </template>
    <v-list-item-group
      no-action
      style="overflow-y: auto"
    >
      <div>
        <dropdown-padrao-item
          v-for="idioma in idiomasPermitidos"
          :key="idioma.value"
          text
          color="secondary"
          @click="alterarIdioma(idioma.value)"
        >
          <img
            :src="idioma.imagem"
            alt="flag"
            style="width: 20px; margin-right: 10px"
          >
          <span>
            {{ idioma.text }}
          </span>
        </dropdown-padrao-item>
      </div>
    </v-list-item-group>
  </v-menu>
</template>
<script>
import helpers from '@common/utils/helpers';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('Autenticacao', ['idiomas']),
    idiomasPermitidos() {
      return helpers.IdiomasEnum.filter((el) =>
        this.idiomas.includes(el.value)
      );
    },
  },
  mounted() {
    this.$i18n.locale = localStorage.getItem('idioma') || 'pt-BR';
  },
  methods: {
    alterarIdioma(idioma) {
      localStorage.setItem('idioma', idioma);
      this.$i18n.locale = idioma;
    },
  },
};
</script>
<style>
.menu-dropdown-idiomas {
  margin-right: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
